export const staticPages = [
  { title: 'Startseite', path: '/' },
  { title: 'Sitemap', path: '/sitemap/' },
  { title: 'Datenschutz', path: '/datenschutz/' },
  { title: 'Impressum', path: '/impressum/' },
  { title: 'Barrierefreiheit', path: '/barrierefreiheit/' },
]
